export default {
    primary: '#11837B',
    secondary: '#d5d5d5',
    primaryhover: '#32A49C',
    background: '#F4F6F7',
    white: '#FFFFFF',
    text:{
        primary: '#000',
        secondary: '#666666'
    }
}


// WEBPACK FOOTER //
// ./src/shared/colors.js